import springCenfApi from '../../services/springCenfApi'

export const getOrders = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/orders', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getOrder = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/orders/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)